import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from '@app/dashboard/dashboard.component';
import { SdsComponent } from '@app/sds/sds.component';
import { KpaLayoutComponent } from './kpa-layout.component';
import { AnnouncementsComponent } from '@app/announcements/announcements.component';

export const PanelbarRoutes: Routes = [
	{
		path: '',
		component: KpaLayoutComponent,
		children: [
			{ path: 'dashboard', component: DashboardComponent },
			{ path: 'sds', component: SdsComponent },
			{ path: 'announcements', component: AnnouncementsComponent },
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(PanelbarRoutes)],
	exports: [RouterModule],
})
export class KpaLayoutRoutingModule {}
